module.exports = __webpack_public_path__ + "static/img/kv2@2x.72929ebf.png";